<script>
import { mapState } from 'vuex';
import MarkerClusterer from '@google/markerclusterer';

export default {
  name: 'GoogleMapsMarkerClusterer',

  data() {
    return {
      markerClusterer: null,
    };
  },

  computed: {
    ...mapState({
      map: (state) => state.google.map,
      markers: (state) => state.markers.markers,
      visibleMarkers: (state) => state.markers.visible,
    }),
  },

  watch: {
    visibleMarkers() {
      this.refreshClusters();
    },
  },

  mounted() {
    this.renderClusters();
  },

  methods: {
    refreshClusters() {
      const visible = [];

      this.markers.forEach((marker) => {
        if (this.visibleMarkers.includes(marker.marker.id)) {
          visible.push(marker);
        }
      });

      this.markerClusterer.clearMarkers();
      this.markerClusterer.addMarkers(visible);
    },

    renderClusters() {
      this.markerClusterer = new MarkerClusterer(
        this.map,
        [],
        {
          imagePath: 'img/marker-clusters/m',
        },
      );
    },
  },

  render() {
    return null;
  },
};
</script>
